import { useMemo } from 'react'
import clsx from 'clsx'
import { Text } from '../ui'
import { formatCurrency, formatDate, formatRut } from '../../utils/formatter'
import iconVinculos from '../../../assets/iconosCardInformes/informe_9.png'
import DoneAllIcon from '@mui/icons-material/DoneAll'

const NOMBRES_ANTICIPO = {
  27: 'Anticipo Agente de Aduana',
  28: 'Anticipo Sueldo'
}

const getRowId = row => row?.idPrincipal ?? row?.id

const TablaVinculacionesAnticipo = ({ rows = [], selectedIds = [], onSelectionChange }) => {
  const safeSelectedIds = Array.isArray(selectedIds) ? selectedIds : []
  const sortedRows = useMemo(
    () => [...rows].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)),
    [rows]
  )

  const toggleRow = row => {
    const id = getRowId(row)
    if (id == null) return
    const isSelected = safeSelectedIds.some(selectedId => String(selectedId) === String(id))
    const nextIds = isSelected
      ? safeSelectedIds.filter(selectedId => String(selectedId) !== String(id))
      : [...safeSelectedIds, id]
    onSelectionChange?.(
      nextIds,
      rows.filter(item =>
        nextIds.some(selectedId => String(selectedId) === String(getRowId(item)))
      )
    )
  }

  const thClass = 'py-2 px-2 text-center border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500'
  const tdClass = 'py-2 px-2 text-center border-b border-gray-100 align-middle'

  return (
    <div className='overflow-x-auto rounded-3xl shadow-sm'>
      <table className='w-full table-auto text-[0.725rem] border-collapse leading-tight'>
        <thead className='sticky top-0 z-10 bg-gray-50'>
          <tr>
            <th className={thClass}></th>
            <th className={thClass}>Fecha</th>
            <th className={thClass}>Vinculación</th>
            <th className={thClass}>Razón Social</th>
            <th className={thClass}>Cuenta / Comprobante</th>
            <th className={thClass}>Monto</th>
            <th className={thClass}>Estado</th>
            <th className={thClass}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {sortedRows.length > 0 ? (
            sortedRows.map(row => {
              const id = getRowId(row)
              const selected = safeSelectedIds.some(
                selectedId => String(selectedId) === String(id)
              )
              return (
                <tr key={id} className='hover:bg-gray-50 transition-colors'>
                  <td className={tdClass}>
                    <div className='flex items-center justify-center gap-2'>
                      <input
                        type='checkbox'
                        className='rounded'
                        checked={selected}
                        onChange={() => toggleRow(row)}
                      />
                      <img src={iconVinculos} alt='Vinculación' className='h-8 w-auto rounded' />
                    </div>
                  </td>
                  <td className={tdClass}><Text className='font-bold'>{formatDate(row.fecha)}</Text></td>
                  <td className={tdClass}>
                    <Text className='font-bold'>{NOMBRES_ANTICIPO[Number(row.folioCredito)]}</Text>
                    <Text className='text-gray-400'>Folio {row.numeroFolio ?? row.folio}</Text>
                  </td>
                  <td className={tdClass}>
                    <Text className='font-bold'>{row.razonSocial}</Text>
                    <Text className='text-gray-400'>{row.rut ? formatRut(row.rut) : ''}</Text>
                  </td>
                  <td className={tdClass}>
                    <Text className='font-bold'>{row.nombreCuenta}</Text>
                    <Text className='text-gray-400'>{row.comprobante}</Text>
                  </td>
                  <td className={tdClass}><Text className='font-bold'>{formatCurrency(row.montoTotal)}</Text></td>
                  <td className={tdClass}>
                    <span className={clsx(
                      'inline-flex rounded-full px-3 py-1 text-[0.62rem] font-semibold uppercase',
                      selected ? 'bg-accent2/10 text-accent2' : 'bg-gray-100 text-gray-500'
                    )}>
                      {row.status || '—'}
                    </span>
                  </td>
                  <td className={tdClass}>
                    <div className='flex flex-col items-center justify-center text-xs text-gray-500'>
                      <button
                        type='button'
                        className={clsx(
                          'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                          selected
                            ? 'bg-accent2 text-white hover:bg-accent2/90'
                            : 'bg-gray-100 text-gray-300 hover:bg-gray-200'
                        )}
                        onClick={() => toggleRow(row)}
                      >
                        <DoneAllIcon className='w-4 h-4' />
                      </button>
                      <Text className='mt-2'>{selected ? 'Seleccionado' : 'Seleccionar'}</Text>
                    </div>
                  </td>
                </tr>
              )
            })
          ) : (
            <tr><td colSpan={8} className='py-6 text-center text-gray-500'>No hay anticipos disponibles</td></tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default TablaVinculacionesAnticipo
